var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4726_11055)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 2.9408L10.0005 1.28076V21.3807L14.6805 22.9508C14.7866 22.9655 14.8943 22.9655 15.0005 22.9508V2.9408Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00042 1.2207L0.760434 3.03076C0.538558 3.08551 0.342135 3.21454 0.203855 3.39648C0.0655739 3.57843 -0.00623105 3.80233 0.000424324 4.03076V22.0308C-0.000393893 22.1827 0.0333978 22.3327 0.0992402 22.4696C0.165083 22.6065 0.26125 22.7266 0.380429 22.8208C0.502574 22.9105 0.642535 22.973 0.790891 23.004C0.939246 23.0351 1.09253 23.034 1.24041 23.0007L8.00042 21.3108V1.2207Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6205 1.21066C23.5003 1.11716 23.3603 1.0524 23.2113 1.02121C23.0623 0.990011 22.9081 0.993274 22.7605 1.03073L17.0005 2.47067V22.5307L23.2405 20.9707C23.4624 20.9159 23.6588 20.7869 23.7971 20.6049C23.9353 20.423 24.0071 20.1991 24.0005 19.9707V1.97067C23.9968 1.82386 23.9609 1.67966 23.8952 1.5483C23.8295 1.41695 23.7357 1.30166 23.6205 1.21066Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4726_11055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSelected);
export default __webpack_public_path__ + "static/media/map_selected.705a2d819defe8e998eaa1354e035639.svg";
export { ForwardRef as ReactComponent };